var _defs, _path, _rect, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLab(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    preserveAspectRatio: "xMidYMid meet",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "5.032 5.2 53.6 53.6",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "lq",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#15a5c7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#5fd7ee"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0d7fa0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "fl"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25 6 L39 6 L39 9 L37 9 L37 24 L54 52 Q57 58 51 58 L13 58 Q7 58 10 52 L27 24 L27 9 L25 9Z"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25 6 L39 6 L39 9 L37 9 L37 24 L54 52 Q57 58 51 58 L13 58 Q7 58 10 52 L27 24 L27 9 L25 9Z",
    fill: "#eaf6fa"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 38,
    width: 64,
    height: 26,
    fill: "url(#lq)",
    clipPath: "url(#fl)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25 6 L39 6 L39 9 L37 9 L37 24 L54 52 Q57 58 51 58 L13 58 Q7 58 10 52 L27 24 L27 9 L25 9Z",
    fill: "none",
    stroke: "#6d8a94",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31 12 L31 25 L20 44",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 2,
    opacity: 0.8,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLab);
export default __webpack_public_path__ + "static/media/lab.11dd0d17a7163c7ac09f1af8b9e70707.svg";
export { ForwardRef as ReactComponent };